import { useEffect, useState } from "react"
import MainLayout from "../../components/layouts/MainLayout"
// import { EyeIcon, EyeSlashIcon } from '@heroicons/react/solid';
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { providerApi } from "../../api/providerApi";
import Swal from "sweetalert2";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { Auth } from "../../utils/Auth";
import { annonceApi } from "../../api/annonceApi";
import { CommandeApi } from "../../api/commandeApi";
import { Select } from 'antd';


const CreateCommandeView = () => {
  const navigate = useNavigate()
  const [annonces, setAnnonces] = useState([])
    const [formData, setFormData] = useState({
        annonce_id: '',
        customer_name: '',
        customer_number: '',
        virtual_amount: '',
        item_name: '',
        total_amount: '',
        mecanicien_id: '',
        
    })
    const [loading, setLoading] = useState(false);
    const abortController = new AbortController()

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSelectChange = (value: string | number, name = 'annonce_id') => {
      setFormData(prev => ({ ...prev, [name]: value }));
    }

    const onSearch = (value: string) => {
      console.log('search:', value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
          // console.log(formData)

          const payload = {
            annonce_id: formData.annonce_id,
            customer_name: formData.customer_name || '',
            customer_number: formData.customer_number,
            virtual_amount: formData.virtual_amount,
            item_name: '',
            total_amount: formData.total_amount || '',
            mecanicien_id: '',
            
          }

          const res = await CommandeApi.storeCommande(JSON.stringify(payload),abortController.signal)

          // console.log(res)

          if (!res.success) {
            return Swal.fire({
              title:'Impossible d\'enregistrer',
              text:res.message,
              // timer:3000
            })
          }

          message.success('Commande ajoutée avec succès');
          setFormData({
            annonce_id: '',
            customer_name: '',
            customer_number: '',
            virtual_amount: '',
            item_name: '',
            total_amount: '',
            mecanicien_id: '',
          });
        } catch (error) {
          message.error('Une erreur est survenue lors de l\'ajout de la commande');
          const messages = await error.messages ?? error.message;

          if(messages instanceof Array)
              return Swal.fire({
                title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                icon:"error",
              }).then((result) => {
                Auth.removeSessionToken()
                return navigate(`/login`)			
              });
        } finally {
          setLoading(false);
        }
    }

    const handlefetchdata = async () => {
            setLoading(true)    
            try {
                const res = await annonceApi.getAnnouncements(abortController.signal)
                if(!res){
                    setLoading(false)
                       return;
    
                }            
                
                setAnnonces(res.data)
                setLoading(false)
     
             } catch (error) {
                 console.log(error)
    
                setLoading(false)
                const messages = await error.messages ?? error.message;
    
              if(messages instanceof Array)
                  return Swal.fire({
                    title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                    text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                    icon:"error",
                  }).then((result) => {
                    if(messages.join('\n') === 'Unauthenticated'){
                        Auth.removeSessionToken()
                        return navigate(`/login`)
                    }   
                            
                  });
     
             }
        }

    useEffect(()=>{
       handlefetchdata()
    },[])

    return <MainLayout>
        <div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Ajouter une commande</h2>
      <form onSubmit={handleSubmit}>
        {/* Informations Utilisateur */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Article <span className="text-red-600 text-sm italic">(Obligatoire)</span> </label>
          <Select
            className="w-full rounded-md"
            showSearch
            placeholder="Selectionner un article"
            optionFilterProp="label"
            onChange={(value) => handleSelectChange(value, 'annonce_id')}
            onSearch={onSearch}
            options={annonces?.map((annonce) => ({
                value: annonce.id,
                label: annonce.title,
              }))}
          />
              
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Nom et prenom client <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <input
            type="text"
            name="customer_name"
            value={formData.customer_name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Contact du client <span className="text-red-600 text-sm italic">(Renseigner s'il a une adresse email)</span></label>
          <input
            type="numeric"
            name="customer_number"
            value={formData.customer_number}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700"> 
            Montant de la commande <span className="text-red-600 text-sm italic">(Optionnel)</span>
          </label>
          <input
            type="numeric"
            name="virtual_amount"
            value={formData.virtual_amount}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
          <small>Si vous ne renseignez pas, le montant de l'article sera recuperé automatiquement</small>
        </div>

        {/* Soumission */}
        <div className="mt-6">
          <button
            type="submit"
            className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
            disabled={loading}
          >
            {loading ? 'Enregistrement...' : 'Ajouter'}
          </button>
        </div>
      </form>
    </div>
    </MainLayout>
}
export default CreateCommandeView